import Download from "@/components/svg/Download";
import Button from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { useLazyDownloadTestReportQuery } from "@/store/sat/satApi";
import { SATError } from "@/store/sat/types";
import { FC } from "react";

type DownloadReportProps = {
  testId: number;
};

const DownloadReport: FC<DownloadReportProps> = ({ testId }) => {
  const { toast } = useToast();
  const [downloadReport, { isLoading }] = useLazyDownloadTestReportQuery();
  const handleDownloadClick = async () => {
    const response = await downloadReport(String(testId));

     if (response.error) {
          const error  = response.error as SATError
          toast({
            description: error?.data?.error||"Failed to download test report!!",
            variant: "destructive"
          });
        } else if (response.data) {
      const blob = new Blob([response.data], { type: "text/html" });
      const link = document.createElement("a");

      link.href = URL.createObjectURL(blob);
      link.download = `report-${testId}.html`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    }
  };

  return (
    <div>
      <Button
        onClick={handleDownloadClick}
        id="download-test-report"
        disabled={isLoading}
        type="button"
        variant={"ghost"}
        className="flex justify-center items-center sat-download-btn gap-2 float-end text-white"
      >
        <Download />
        Report
      </Button>
    </div>
  );
};

export default DownloadReport;
